import JassEnum from './enum';

/**
 * type gamestate
 */
export default class JassGameState extends JassEnum {}
